import * as yup from "yup";

export const paymentsEmailSchema = yup.string().matches(/^$|^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, "Payment email is invalid");